/**
 * @typedef {import('../runner.js').Runner} Runner
 * @typedef {import('../test.js')} Test
 */

/**
 * @module Spec
 */
/**
 * Module dependencies.
 */

import { Base } from "./base.js";
import { Runner } from "../runner.js";
var constants = Runner.constants;
var EVENT_RUN_BEGIN = constants.EVENT_RUN_BEGIN;
var EVENT_RUN_END = constants.EVENT_RUN_END;
var EVENT_SUITE_BEGIN = constants.EVENT_SUITE_BEGIN;
var EVENT_SUITE_END = constants.EVENT_SUITE_END;
var EVENT_TEST_FAIL = constants.EVENT_TEST_FAIL;
var EVENT_TEST_PASS = constants.EVENT_TEST_PASS;
var EVENT_TEST_PENDING = constants.EVENT_TEST_PENDING;
var color = Base.color;

class Spec extends Base {
  static description = "hierarchical & verbose [default]";

  /**
   * Constructs a new `Spec` reporter instance.
   *
   * @public
   * @memberof Mocha.reporters
   * @extends Mocha.reporters.Base
   * @param {Runner} runner - Instance triggers reporter actions.
   * @param {Object} [options] - runner options
   */
  constructor(runner, options) {
    super(runner, options);

    var indents = 0;
    var n = 0;

    function indent() {
      return Array(indents).join("  ");
    }

    runner.on(EVENT_RUN_BEGIN, function () {
      Base.consoleLog();
    });

    runner.on(EVENT_SUITE_BEGIN, function (suite) {
      ++indents;
      Base.consoleLog(color("suite", "%s%s"), indent(), suite.title);
    });

    runner.on(EVENT_SUITE_END, function () {
      --indents;
      if (indents === 1) {
        Base.consoleLog();
      }
    });

    runner.on(EVENT_TEST_PENDING, function (test) {
      var fmt = indent() + color("pending", "  - %s");
      Base.consoleLog(fmt, test.title);
    });

    runner.on(EVENT_TEST_PASS, function (test) {
      var fmt;
      if (test.speed === "fast") {
        fmt =
          indent() +
          color("checkmark", "  " + Base.symbols.ok) +
          color("pass", " %s");
        Base.consoleLog(fmt, test.title);
      } else {
        fmt =
          indent() +
          color("checkmark", "  " + Base.symbols.ok) +
          color("pass", " %s") +
          color(test.speed, " (%dms)");
        Base.consoleLog(fmt, test.title, test.duration);
      }
    });

    runner.on(EVENT_TEST_FAIL, function (test) {
      Base.consoleLog(indent() + color("fail", "  %d) %s"), ++n, test.title);
    });

    runner.once(EVENT_RUN_END, (...args) => this.epilogue(...args));
  }
}

export { Spec };
